import { render, staticRenderFns } from "./DeveloperLogin.vue?vue&type=template&id=622df5d0&"
import script from "./DeveloperLogin.vue?vue&type=script&lang=js&"
export * from "./DeveloperLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports